// TODO update copy
import type { AssetWorkflowOptions } from '../../types';
import { InvalidPartnerProvidedIDMessage, PartnerProvidedIDValidationRegex } from '../../types';

export const addThirdPartyBillingAccountSet: AssetWorkflowOptions = {
  workflowKey: 'addThirdPartyBillingAccountSet',
  workflowType: 'addAssetWorkflow',
  assetType: 'thirdPartyBillingAccountSet',
  workflowIndex: 1,
  workflowName: 'Third Party Billing Group',
  workflowDescription: 'Create a third party billing group',
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Third Party Billing Account Group ID Alias',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique ID that you will use to reference this billing group in carrier selection calls. ',
        description:
          'This is optional but will allow you to more easily reference this third party billing group in carrier selection calls',
        help: '',
        validationRegex: PartnerProvidedIDValidationRegex,
        validationMessage: InvalidPartnerProvidedIDMessage,
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'thirdPartyBillingAccounts',
      workflowStepNavigationName: 'Third Party Billing Accounts',
      workflowComponent: {
        workflowComponentType: 'thirdPartyBillingAccountSelect',
        prompt: 'Select the accounts that will be billed for this group',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'thirdPartyBillingAccount',
        list: true,
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Group Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter a name for this third party billing group',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 10,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Third Party Billing Group Summary',
        description: 'The following third party billing group will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
